module.exports = __webpack_public_path__ + "img/facebook-icon.c5279670.svg";